import { privateApi } from "../api/axios";

export const setPasswordClient = async (password: string, token: string) => {
  try {
    const response = await privateApi.post("api/clientportal/setpassword", {
      password,
      token,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export const getDocumentsClient = async () => {
  try {
    const response = await privateApi.get("api/clientportal")
    return response;
  } catch (error) {
    throw error;
  }
}

export const getInvoicePdf = async (id: number) => {
  try {
    const response = await privateApi.get(`api/clientportal/invoices/documents?ids=${id}`, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export const getCreditNotesPdf = async (id: number) => {
  try {
    const response = await privateApi.get(`api/clientportal/creditNotes/documents?ids=${id}`, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export const getDocumentPdf = async (id: number) => {
  try {
    const response = await privateApi.get(`api/clientportal/customerfilesdocuments/documents?ids=${id}`, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    throw error;
  }
}